export var BlurbFinder = (window.BlurbFinder = new Class({
   Extends: Autocompleter.Request.JSON,

   el: null,

   initialize: function(el, url, options) {
      options = Object.merge(
         {
            fxOptions: null,
            className: options.className || 'blurb-finder',
            maxChoices: 5,
            truncateText: false,
            showImage: true,
            overflow: false,
            postVar: 'search',
            injectChoice: this.injectChoice.bind(this),
            filterSubset: true,
            onShow: this.onShow.bind(this),
         },
         options
      );

      this.el = el;

      this.parent(this.el, url, options);

      // Prevent blur event from firing in Safari when dragging the scrollbar
      this.choices.addEvent('mousedown', function(ev) {
         ev.stop();
      });
   },

   onShow: function(el, choices) {
      var blurbDimens = choices.getElement('.blurb-item').getDimensions(true);
      var blurbWidth = blurbDimens.width;
      var choiceSpacing = 20; // padding of choice + margin-right on image
      var choiceText = choices.getElements('.blurb-text');
      var choiceImage = choices.getElement('.blurb-image');
      var imageWidth = choiceImage.getDimensions(true).width;

      var choiceTextWidth = blurbWidth - imageWidth - choiceSpacing;

      choiceText.each(function(text) {
         text.setStyle('width', choiceTextWidth);
      });
   },

   injectChoice: function(blurb) {
      if (!this.el.isDisplayed()) {
         return;
      }

      var text =
         blurb.text && this.options.truncateText
            ? blurb.text.truncate(this.options.truncateText)
            : blurb.text;
      text = this.markQueryValue(text ? text : '');

      var data = {
         showImage: this.options.showImage,
         blurbImage: blurb.mini,
         title: blurb.displayTitle,
         displayTitle: this.markQueryValue(blurb.displayTitle),
         summary: text,
      };

      if (!blurb.newItem) {
         data.blurbId = 'blurb-' + blurb.type + '-' + blurb.id;
      } else {
         data.blurbId = 'blurb-new';
      }

      var template = window.hbsTemplates('BLURB_HBS');

      var choice = template(data);

      choice.store('blurb', blurb);
      choice.inputValue = this.options.getValue
         ? this.options.getValue(blurb)
         : blurb.type + ':' + blurb.id;

      if (blurb.newItem) {
         choice.addClass('blurb-add-new');
      }

      this.addChoiceEvents(choice).inject(this.choices);
   },
}));
